import { processTemplate } from "@imminently/decisively-core";

type CsvColumn = {
  header?: string;
  field?: string;
  value?: unknown;
  required?: boolean;
  multilineFields?: Record<string, string>;
};

/** Validate source values before type conversion, identifier fallbacks, or record merging. */
export const validateRequiredCsvColumns = (
  mapping: { columns?: CsvColumn[]; entityMapping?: { type?: string; column?: string } },
  rows: Record<string, unknown>[],
): void => {
  const columns = (mapping.columns || []).filter((column) => column.required === true);
  for (const row of rows) {
    for (const column of columns) {
      const entityMapping = mapping.entityMapping;
      if (
        entityMapping?.type === "multiline" &&
        column.multilineFields &&
        Object.keys(column.multilineFields).length > 0 &&
        !column.multilineFields[String(row[entityMapping.column || ""] ?? "")]
      )
        continue;

      const header = column.header || "";
      const label = header || column.field || "unknown";
      let value: unknown;
      if (column.value !== undefined && column.value !== "") {
        value =
          typeof column.value === "string" && column.value.includes("{{")
            ? processTemplate(column.value, row)
            : column.value;
      } else if (header.includes("{{")) {
        value = processTemplate(header, row);
      } else if (/^(["']).*\1$/.test(header.trim())) {
        value = header.trim().slice(1, -1);
      } else {
        const key = Object.prototype.hasOwnProperty.call(row, header)
          ? header
          : Object.keys(row).find(
              (key) =>
                key.trim().replace(/\s+/g, " ").toLowerCase() === header.trim().replace(/\s+/g, " ").toLowerCase(),
            );
        if (key === undefined) throw new Error(`Required CSV column '${label}' is missing`);
        value = row[key];
      }
      if (value === undefined || value === null || (typeof value === "string" && !value.trim())) {
        throw new Error(`Required CSV column '${label}' is blank`);
      }
    }
  }
};
